'use client'

import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'

import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { toast } from 'react-toastify'

import { cn } from '@/utils/cn'

interface TProps {
  comingSoon?: string
  tabs: { key: string; value: string; isDisabled?: boolean }[]
  activeTab: number
  setActiveTab: Dispatch<SetStateAction<number>>
  className?: string
  isScroll?: boolean
  isCenter?: boolean
  paramKey?: string
}

const TabSlider = ({
  tabs,
  comingSoon,
  activeTab,
  setActiveTab,
  className,
  isScroll,
  isCenter,
  paramKey = 'tab',
}: TProps) => {
  const tabRefs = useRef<(HTMLParagraphElement | null)[]>([])
  const [sliderStyles, setSliderStyles] = useState<{ width: number; left: number }>({ width: 111, left: 0 })
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const getParams = useSearchParams().get(paramKey) as string

  const handleTabClick = (type: string, index: number, isDisabled?: boolean) => {
    if (isDisabled) return
    if (comingSoon === type) return toast.info('Coming soon')

    const params = new URLSearchParams(searchParams)
    params.set(paramKey, type)
    params.delete('category')
    router.replace(`${pathname}?${params.toString()}`, { scroll: false })

    setActiveTab(index)
  }

  useEffect(() => {
    if (getParams === null) {
      const params = new URLSearchParams(searchParams.toString())
      params.set(paramKey, tabs[0].key)

      return router.replace(`${pathname}?${params.toString()}`, { scroll: false })
    }

    const index = tabs.findIndex((i) => i.key?.includes(getParams))

    setActiveTab(index !== -1 ? index : 0)
  }, [getParams])

  useEffect(() => {
    const currentTab = tabRefs.current[activeTab]
    if (currentTab) {
      setSliderStyles({
        width: currentTab.offsetWidth,
        left: currentTab.offsetLeft,
      })
    }
  }, [activeTab])
  return (
    <div
      className={cn(
        'relative mx-0 md:mx-5 flex w-full px-6 md:px-0 md:w-3/5 items-center justify-between gap-x-16 pb-2 pt-4 hidden_scroll',
        {
          'overflow-x-auto': isScroll,
          'md:mx-auto': isCenter,
        },
        className,
      )}
    >
      {tabs.map(({ key, value, isDisabled }, index) => (
        <button
          key={key}
          disabled={isDisabled}
          className={`${activeTab === index ? 'text-ss-purple-100' : 'text-ss-grayscale-500'} w-fit text-nowrap text-sm md:text-base`}
          onClick={() => handleTabClick(key, index, isDisabled)}
        >
          <p
            ref={(el) => {
              tabRefs.current[index] = el
            }}
          >
            {value}
          </p>
        </button>
      ))}

      <div
        className="absolute bottom-0 left-0 h-[2px] bg-ss-primary transition-all duration-300 ease-in-out"
        style={{
          width: `${sliderStyles.width}px`,
          transform: `translateX(${sliderStyles.left}px)`,
        }}
      />
    </div>
  )
}

export default TabSlider
